
export const getSearchParam = function (param) {
  if (__SERVER__ || !window || !window.location || !window.location.search) { return null; }
  const currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get(param);
}



// WEBPACK FOOTER //
// ../src/client/utils/url.js